import { z } from 'zod';
import { InstantSchema } from './instant.js';
import { IanaTimeZoneSchema } from './iana-time-zone.js';
/**
 * ZonedDateTime — an Instant plus the IanaTimeZone in which the event was
 * experienced. Used only when both facts matter together (design §3.5).
 *
 * Wire shape: `{ "instant": "...Z", "zone": "..." }`.
 *
 * Declared `.strict()` so extra top-level keys are rejected — strips would
 * silently drop unknown fields and mask upstream bugs. Per design §5 the
 * schema is composed of the two sibling schemas so validation flows through
 * a single boundary.
 */
export const ZonedDateTimeSchema = z
    .object({
    instant: InstantSchema,
    zone: IanaTimeZoneSchema,
})
    .strict();
//# sourceMappingURL=zoned-date-time.js.map